<template>
    <div>
        <veui-dialog
            v-if="bindPhoneDialogShow"
            title=""
            :open.sync="bindPhoneDialogShow"
            :closable="false"
            overlay-class="bind-phone-dialog"
        >
            <template #title>
                <div class="bind-phone-title">
                    <span class="bind-phone-title-text">{{ titleMap[dialogType] }}</span>
                    <span @click="handleClick('cancel')">
                        <veui-icon class="bind-phone-title-close" name="times"/>
                    </span>
                </div>
            </template>
            <div v-if="dialogType === 'recordList'" class="bind-phone-content-bind">
                <bind-phone-table :record-data="recordData"/>
            </div>
            <div v-else class="bind-phone-content-bind">
                <template v-if="singleBindSuccess && !bindWarningShow">
                    <bind-phone-success :bind-info="bindInfo"></bind-phone-success>
                </template>
                <template v-else>
                    <div class="bind-phone-tip">
                        <veui-icon class="bind-phone-tip-icon" name="exclamation-circle-solid"/>
                        <div class="bind-phone-tip-text">绑定后,您有30min时间与用户取得电话联系,请确认您可以通话后再绑定,避免无效绑定。</div>
                    </div>
                    <veui-form
                        ref="form"
                        :data="formData"
                        :validators="validators"
                        class="bind-phone-form"
                    >
                        <veui-field
                            name="tel"
                            label="呼出号码"
                            class="desc-warp"
                            :rules="[{name: 'required', value: true, message: '请输入您将要拨打用户电话的手机号码'}]"
                        >
                            <veui-input v-model="formData.tel" placeholder="请输入您将要拨打用户电话的手机号码"/>
                            <div v-if="bindWarningShow" class="bind-warning">{{ bindWarningShow }}</div>
                        </veui-field>
                    </veui-form>
                    <div v-if="surplus !== ''" class="bind-tip">该线索剩余绑定次数{{ surplus }}次</div>
                </template>
            </div>
            <template #foot>
                <veui-button
                    v-if="!singleBindSuccess && dialogType !== 'recordList' && !bindWarningShow"
                    class="bind-phone-button"
                    ui="m primary"
                    :loading="buttonLoading"
                    :disabled="!formData.tel"
                    @click="submit"
                >
                    确认绑定
                </veui-button>
                <veui-button
                    v-else
                    ui="m primary"
                    :loading="buttonLoading"
                    @click="handleClick('cancel')"
                >
                    我知道了
                </veui-button>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file bindPhoneDialog.vue
 * @author sunxiaofeng01
 * @desc 虚拟号绑定弹窗
 */
import {Dialog, Button, Icon, Input, Form, Field} from 'veui';
import 'veui-theme-dls-icons/exclamation-circle-solid';
import 'veui-theme-dls-icons/times';
import {isBoolean, get, cloneDeep} from 'lodash';
import bendSDK from '@baidu/bend-plugin-sdk';
import bindPhoneTable from './bindPhoneTable';
import bindPhoneSuccess from './bindPhoneSuccess';

const url = {
    clueBind: 'law:/themis/law/commodity/clue_bind',
    clueBindList: 'law:/themis/law/commodity/clue_bind_list'
};
export default {
    name: 'bind-phone-dialog',
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-input': Input,
        'veui-icon': Icon,
        'veui-field': Field,
        'veui-form': Form,
        'bind-phone-table': bindPhoneTable,
        'bind-phone-success': bindPhoneSuccess
    },
    props: {
        show: {
            'type': Boolean,
            'default': false
        },
        dialogType: {
            'type': String,
            'default': 'phoneBind'
        },
        clueId: {
            'type': [String, Array],
            'default': ''
        },
        surplus: {
            'type': String,
            'default': ''
        }
    },
    data() {
        return {
            bindPhoneDialogShow: false,
            buttonLoading: false,
            titleMap: {
                phoneBind: '主呼号绑定',
                changeBind: '主呼号更换绑定',
                recordList: '绑定记录'
            },
            singleBindSuccess: false,
            bindInfo: {},
            recordData: [],
            bindWarningShow: '',
            formData: {
                tel: null
            },
            validators: [
                {
                    fields: ['tel'],
                    validate(tel) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                let isPhone = /^1[3456789]\d{9}$/.test(tel);

                                if (tel && !isPhone) {
                                    res = {
                                        tel: '请输入正确的手机号'
                                    };
                                }
                                return resolve(res);
                            });
                        });
                    }
                }
            ]
        };
    },
    watch: {
        show(next, pre) {
            this.bindPhoneDialogShow = next;
            this.formData.tel = null;
            this.bindWarningShow = '';
            this.titleMap.phoneBind = '主呼号绑定';
        },
        clueId(next, pre) {
            // 只有dialogType为绑定记录时发送请求
            if (this.dialogType === 'recordList') {
                this.getRecordList();
            }
        }
    },
    methods: {
        // 关闭弹窗
        handleClick(type) {
            if (type === 'cancel') {
                this.$emit('handleBindPhone', true);
                this.singleBindSuccess = false;
            }
        },
        // 绑定手机号提交
        submit() {
            this.$refs.form.validate().then(flag => {
                if (isBoolean(flag) && flag) {
                    this.buttonLoading = true;
                    this.postData();
                }
                else {
                    let toast = {
                        content: '请完成必填选项',
                        duration: 1
                    };
                    this.$Message.info(toast);
                }
            });
        },
        postData() {
            const data = {
                tel: this.formData.tel,
                clue_ids: Array.isArray(this.clueId) ? cloneDeep(this.clueId).join(',') : this.clueId,
                read_firm: this.surplus ? 0 : 1
            };
            this.$http.post(url.clueBind, {
                ...data,
                params: JSON.stringify(data)
            }).then(resp => {
                const data = resp?.data?.data || {};
                if (get(data, 'errno') === 0) {
                    const bindInfoList = get(data, 'data');
                    // 单条绑定成功单独设计，批量绑定成功toast提示
                    if (bindInfoList.length === 1) {
                        if (+data[0].errno === 0) {
                            this.titleMap.phoneBind = '主呼号绑定成功';
                            this.bindInfo = data[0].data || {};
                            // is_new_bind 是否新绑定 0：不是 1：是
                            // is_tel_first_bind 是否是第一次绑定 0：不是 1：是
                            this.singleBindSuccess = +this.bindInfo.is_new_bind === 1;
                            if (+this.bindInfo.is_new_bind === 0 && +this.bindInfo.is_tel_first_bind === 0) {
                                this.bindWarningShow = '该呼叫号码目前已绑定在此线索上，再次绑定不会重新计时，建议您该绑定失效后再操作。';
                            }
                            else if (+this.bindInfo.is_new_bind === 1 && +this.bindInfo.is_tel_first_bind === 0) {
                                this.bindWarningShow = '该呼叫号码已绑定过，系统不限制同一主呼号码对同一个线索多次绑定。';
                            }
                            else {
                                this.bindWarningShow = '';
                            }
                        }
                        else if (+data[0].errno === 92008) {
                            this.bindWarningShow = get(data, 'data[0].errmsg', '超过最大的绑定次数');
                        }
                        else {
                            this.$Message.error('抱歉，绑定失败，请您重新操作绑定。');
                        }
                    }
                    else {
                        let failList = [];
                        failList = bindInfoList.filter((item, index) => {
                            item.idxName = '线索' + (index + 1);
                            return +item.errno !== 0;
                        });
                        if (failList.length) {
                            const errorText = `${failList.map(item => item.idxName).join('、')}批量绑定操作失败，请重新绑定`;
                            this.$Message.error(errorText);
                        }
                        else {
                            this.$Message.success('批量绑定操作成功，您可在绑定记录中查看具体绑定结果');
                        }
                        this.handleClick('cancel');
                    }
                }
            }).catch(err => this.$normalizeResponseError(err))
                .finally(() => this.buttonLoading = false);
        },
        // 绑定记录
        getRecordList() {
            this.$http.get(url.clueBindList, {
                params: {
                    clue_id: this.clueId
                }
            }).then(resp => {
                const data = resp?.data?.data || {};
                if (data) {
                    this.recordData = get(data, 'data', []);
                }
            }).catch(err => this.$normalizeResponseError(err));
        }
    }
};
</script>

<style lang="stylus" scoped>
.bind-phone-dialog
    /deep/ .veui-dialog-content
        width 440px
        .veui-dialog-content-foot
            padding-top 0px
            .bind-phone-button
                margin-top 12px
        .veui-dialog-content-body
            font-family PingFangSC-Regular
            font-size 14px
            color #282C33
            letter-spacing 0
            line-height 25px
            .bind-phone-tip
                display flex
                padding 4px 23px 4px 16px
                background #F0F6FF
                border-radius 4px
                .bind-phone-tip-icon
                    font-size 22px
                    color #0052CD
                    margin -1px 8px 0 0
            .bind-phone-form
                margin-top 24px
                .veui-field-label
                    width auto
                    margin-right 24px
                .veui-field-required > .veui-field-label::before
                    content ''
                .veui-field-content
                    flex-wrap wrap
                    width 100%
                    flex 1 0
                .bind-warning
                    color #FFA733
                    margin-top 8px
            .bind-tip
                font-size: 14px;
                color: #ffa733;
                line-height: 14px;
                padding-left: 84px;
                margin-top: -24px;
        .bind-phone-title
            width 100%
            font-family PingFangSC-Medium
            font-size 20px
            display flex
            align-items center
            justify-content space-between
            .bind-phone-title-text
                flex 1
            .bind-phone-title-close
                font-size 20px
                cursor pointer
                color #848B99
</style>
